import datetounicode from 'datetounicode'
import datascene from './datascene.js'

import {
  gnnodeosxGet as nodeosxGet
} from '@bumblehead/gani/src/gnnodeos.js'

// Get a random integer between `min` and `max`.
//
// @param {number} min - min number
// @param {number} max - max number
// @return {int} a random integer
//
const getRandomInt = (min, max) => (
  Math.floor(Math.random() * (max - min + 1) + min))

const getRandomBool = () => (
  Math.random() >= 0.5)

// starting color
//
//   color: "rgba(33, 148, 206)"
//   color: 0x2194ce
//
// random blue, blue 190-210
// random blue green 120-160
const randomblue = () => (
  'rgba(:r, :g, :b, 1)'
    .replace(/:r/, 80)
    .replace(/:g/, getRandomInt(120, 160))
    .replace(/:b/, getRandomInt(190, 210)))

// starting color
//
//   color: "rgba(255, 255, 0)"
//   color: 0xffff000
//
// random blue, blue 190-210
// random blue green 120-160
const randomyellow = () => (
  'rgba(:r, :g, :b, 1)'
    .replace(/:r/, 255)
    .replace(/:g/, getRandomInt(220, 255))
    .replace(/:b/, getRandomInt(0, 50)))

const randomthemecolor = () => (
  getRandomBool() ? randomblue() : randomyellow())

const getrandomposition = () => (
  (Math.random() - 0.5) * 200)

const getrandomrotation = () => (
  Math.random())

const getuuid = () => (
  String(Date.now() + String(Math.floor(100 * Math.random()))))

const getrandomsceneshape = () => ({
  uuid: getuuid(),
  color: randomthemecolor(),
  geometry: [
    100, 100, 100
  ],
  position: [
    getrandomposition(),
    getrandomposition(),
    getrandomposition()
  ],
  rotation: [
    getrandomrotation(),
    getrandomrotation(),
    getrandomrotation()
  ]
})


const getrandomsceneshapes = (numshapes = 0, opt) => {
  const shapes = []

  while (numshapes--) {
    shapes.push(getrandomsceneshape([opt]))
  }

  return shapes
}

const getrandomscene = () => getrandomsceneshapes(3, {})
  .reduce((scene, shape, i) => {
    if (i === 0) {
      // 400, 200, 128
      //
      // where [120, 0] are 'centered'...
      // influences at least one shape to be visible.
      //
      shape.position[0] = getRandomInt(60, 180)
      shape.position[1] = getRandomInt(-20, 20)
    }

    scene.shapedict[shape.uuid] = shape
    scene.sequences.push({
      type: 'shape',
      end: Infinity,
      start: -Infinity,
      isactive: true,
      uuid: shape.uuid
    })

    return scene
  }, {
    shapedict: {},
    sequences: []
  })

const $getuuid = (gst, qst) => {
  qst.target = getuuid()

  return qst
}

// consider using q.add(args)
const $joinstr = (gst, qst) => {
  qst.target = qst.target.join(', ')

  return qst
}

const $getrequrl = (gst, qst) => {
  const ganix = (gst.state.ganix || {})

  qst.target = (ganix.sess || {}).requrl

  return qst
}

const $getrandomsceneshape = (gst, qst) => {
  qst.target = getrandomsceneshape()

  return qst
}

const $getrandomscene = (gst, qst) => {
  qst.target = getrandomscene()

  return qst
}

const $getscenenodelabel = (gst, qst) => {
  const ganix = (gst.state.ganix || {})
  const sess = ganix.sess
  const cfg = ganix.cfg
  const baseelem = qst.target
  const { start, type, uuid } = baseelem

  qst.target = datascene.getndscenelabel(
    [{ start, type, uuid }, {}], sess, cfg)

  return qst
}

const $getsceneshapeskeyarr = async (gst, qst) => {
  const ganix = (gst.state.ganix || {})
  const graph = ganix.graph
  const sess = ganix.sess
  const cfg = ganix.cfg

  const scenenode = qst.target
  const sceneui = scenenode
    && nodeosxGet(cfg, graph, scenenode)

  qst.target = await sceneui
    .getseqshapekeyarr(sess, cfg, graph, scenenode)

  return qst
}

const $datefmt = async (gst, qst, args) => {
  const date = new Date(qst.target)
  const format = args[0]
  const tzOffset = args[1]

  qst.target = datetounicode(date, format, null, tzOffset)

  return qst
}

export {
  $getrequrl,
  $getuuid,
  $joinstr,
  $getrandomscene,
  $getrandomsceneshape,
  $getscenenodelabel,
  $getsceneshapeskeyarr,
  $datefmt
}
